// extracted by mini-css-extract-plugin
export default {"mainDiv":"input_mainDiv__f8s3h","labelClass":"input_labelClass__p9sZI","inputClass":"input_inputClass__XYmY1"};